module.exports = __webpack_public_path__ + "473dafe1c35ff23e5426c7b1735c8eee.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/1/Waqar_Spotin_news.jpg
// module id = 233
// module chunks = 0